import { render, staticRenderFns } from "./CorrespondenceDashboard.vue?vue&type=template&id=2b7c6cf7"
import script from "./CorrespondenceDashboard.vue?vue&type=script&lang=js"
export * from "./CorrespondenceDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports